import { ContentTabName } from '@townsquare/content-tabs/types';
import { createRelayResource } from '@townsquare/relay-utils';

import ProjectUpdatesQuery, {
	type ProjectUpdatesQuery as ProjectUpdatesQueryType,
} from '../components/ProjectUpdatesTab/__generated__/ProjectUpdatesQuery.graphql';
import ProjectViewQuery, {
	type ProjectViewQuery as ProjectViewQueryType,
} from '../components/__generated__/ProjectViewQuery.graphql';

export const projectViewResource = createRelayResource<ProjectViewQueryType>({
	getQuery: routerContext => {
		return {
			query: ProjectViewQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
			},
		};
	},
});

export const projectUpdatesResource = createRelayResource<ProjectUpdatesQueryType>({
	getQuery: routerContext => {
		const tabName = routerContext.match.params.tabName;
		const isUpdatesTab = tabName === ContentTabName.UPDATES;

		return {
			query: ProjectUpdatesQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				isUpdatesTab,
			},
		};
	},
});
